import React from 'react';

const BackgroundVideo = () => {
  return (
    <video
      className="absolute top-0 left-0 w-full h-full object-cover -z-10 opacity-50"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src="/background-video.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default BackgroundVideo;